$primary: #82bc44;
$text: #111827;
$muted: #6b7280;
$hover: #f3f4f6;
$border: #e5e7eb;
$bg: #f9fafb;

.wrapper {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5rem;
	font-size: 15px;
}

.option {
	display: flex;
	align-items: center;
	gap: 0.35rem;
	padding: 0.4rem 0.75rem;
	border-radius: 0.5rem;
	cursor: pointer;
	color: $text;
	font-weight: 500;
	border: 1px solid $border;
	background-color: $bg;
	transition: all 0.2s ease;

	&:hover {
		background-color: $hover;
		border-color: $primary;
		color: $primary;

		svg {
			color: $primary;
		}
	}
}

.icon {
	color: inherit;
	transition: color 0.2s ease;
}

.active {
	background-color: rgba(130, 188, 68, 0.12);
	border-color: $primary;
	color: $primary;
	font-weight: 600;

	.icon {
		color: $primary;
	}
}
